export default class {
  static extend(out) {
    out = out || {};

    for (let i = 1; i < arguments.length; i++) {
      let obj = arguments[i];

      if (!obj) continue;

      for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            if (obj[key] instanceof Array) {
              out[key] = obj[key].slice(0);
            } else {
              out[key] = this.extend(out[key], obj[key]);
            }
          } else {
            out[key] = obj[key];
          }
        }
      }
    }

    return out;
  }
}
